/* ---------------- helpers ---------------- */
export const norm = s => (s ?? "").toString().trim().toLowerCase();

// Slightly stronger normalization for name matching
export const normStrong = (s = "") =>
  s
    .toLowerCase()
    .normalize("NFKC")
    .replace(/\s+/g, " ")    // collapse runs of spaces
    .replace(/[^\p{L}\p{N} ]+/gu, "")   // strip punctuation except spaces
    .trim();

// Normalization for usernames
export const userNorm = (s = "") =>
  String(s)
    .toLowerCase()
    .normalize("NFKC")
    .replace(/@.*$/, "")   // drop domain
    .trim();

// Check for the presence of column through different common name formats (ssms vs snowflake)
// Example 'staffname' could access StaffName, STAFFNAME, staff_name, etc.
// key canonicalizer: lower-case and strip non a–z/0–9
const _kn = (s) => String(s).toLowerCase().replace(/[^a-z0-9]/g, "");
/** Canonical column accessor */
export const cn = (row, col, fallback = "") => {
  const want = _kn(col);
  for (const k in row) {
    if (_kn(k) === want) {
      const v = row[k];
      return v == null ? fallback : v;
    }
  }
  return fallback;
};

/** Normalize the “active employee” flag coming back as boolean/Yes/No/0/1/string */
export const isInactiveEmp = (e) => {
  // Temporary fix as Christie Russell resigned (crussell@bmss.com)
  const name = cn(e, "staffuser", null);
  if (name === "crussell@bmss.com") return true;
  if (name === "kivan@bmss.com") return true;
  if (name === "tpark@bmss.com") return true; //taylor park resigned 5/15/2026
  if (name === "lrandall@bmss.com") return true; //liza randall hardcoded 9/24/26
  const a = cn(e, "active_employee", null);
  const s = String(a).toLowerCase();
  return a === false || s === "no" || s === "false" || Number(a) === 0;
};

// Timestamp standardization
function parseAnyTs(v) {
  if (v == null) return null;
  if (v instanceof Date) return v;

  if (typeof v === "number") {
    return new Date(v < 1e12 ? v * 1000 : v);
  }

  const s = String(v).trim();

  // Snowflake style: "YYYY-MM-DD HH:mm:ss[.SSS] +HHMM"
  let m = s.match(/^(\d{4}-\d{2}-\d{2})[ T](\d{2}:\d{2}:\d{2}(?:\.\d{1,9})?)\s([+-]\d{2})(\d{2})$/);
  if (m) return new Date(`${m[1]}T${m[2]}${m[3]}:${m[4]}`);

  // Snowflake style with colon: "YYYY-MM-DD HH:mm:ss[.SSS] +HH:MM"
  m = s.match(/^(\d{4}-\d{2}-\d{2})[ T](\d{2}:\d{2}:\d{2}(?:\.\d{1,9})?)\s([+-]\d{2}):(\d{2})$/);
  if (m) return new Date(`${m[1]}T${m[2]}${m[3]}:${m[4]}`);

  // Last resort: try letting Date parse (works for ISO: "...T...Z")
  const d = new Date(s.replace(" ", "T"));
  return Number.isNaN(+d) ? null : d;
}

// Timestamp display
export function formatForCell(ts) {
  const d = parseAnyTs(ts);
  if (!d) return { text: "—", title: "" };
  return {
    text: d.toLocaleDateString(),                         // cell text (date only)
    title: d.toLocaleString(),                            // hover: date + time in user's TZ
  };
}